import { BlockOutlined, ChevronRight, DeleteSweepRounded, SearchRounded } from '@mui/icons-material';
import {
    Avatar,
    Button,
    ButtonGroup,
    CardContent,
    Chip,
    Grid,
    IconButton,
    ListItemAvatar,
    ListItemText,
    Pagination,
    Paper,
    Stack,
} from '@mui/material';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useFetch } from '../../../hooks/useFecth';
import DialogMigrate from '../../DialogMigrate';
import DialogAdvertiser from './components/DialogAdvertiser';
import { SearchDrawer } from './components/SearchDrawer';
import DialogOffer from './components/DialogOffer';
import useDialog from '../../../hooks/useDialog';
import SelectStoreLomadee from './components/SelectStoreLomadee';
import SelectStoresCouponsLomadee from './components/SelectStoresCouponsLomadee';

// Helper function to format the vigency date string
const formatVigency = vigencyString => {
    if (!vigencyString) return 'N/A';
    // Assuming vigencyString is like "01/01/2026 02:59:00"
    // We want to extract the date part "01/01/2026"
    const datePart = vigencyString.split(' ')[0];
    // Further parsing/validation can be added if necessary
    // e.g., to convert DD/MM/YYYY to a Date object and then to a locale string
    // For now, just returning the date part.
    // You could use a library like date-fns for more robust parsing and formatting if needed.
    return datePart;
};

export default function CuponsSocialSoul() {
    const [searchParams, setParams] = useSearchParams();

    const [coupon, setCoupon] = useState();
    const [store, setStore] = useState();
    const { handleOpen } = useDialog('offer');

    const { data, mutate } = useFetch(store?.id ? 'brokers/socialsoul/coupons' : null, { params: { ...Object.fromEntries(searchParams) } });

    const handleClearFilters = () => {
        setParams({});
    };

    const handlePage = (event, page) => {
        // Atualiza os parâmetros da URL, mantendo todos os outros e apenas mudando o parâmetro 'page'
        setParams(prevParams => {
            const newParams = new URLSearchParams(prevParams);
            newParams.set('page', page); // Define o número da página na URL
            return newParams;
        });
    };

    const openOfferSyncModal = coupon => {
        handleOpen();
        coupon && setCoupon(coupon);
    };

    const hasFilters = Array.from(searchParams.entries()).some(([key, value]) => value !== '' && value !== null);

    return (
        <Container maxWidth="xl">
            <Stack pb={2}>
                <Typography variant="h2">SocialSoul</Typography>
            </Stack>

            <Card>
                <CardContent>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12}>
                            <SelectStoresCouponsLomadee
                                value={store?.id || ''}
                                name="storeId"
                                label="Selecione a loja para ver as ofertas e comissões"
                                onChange={selectedStore => {
                                    setStore(selectedStore);
                                    setParams(prevParams => {
                                        const newParams = new URLSearchParams(prevParams);
                                        if (selectedStore?.id) {
                                            newParams.set('storeId', selectedStore.id);
                                        } else {
                                            newParams.delete('storeId'); // Remove if no store is selected
                                        }
                                        newParams.set('page', 1); // Reset page when store changes
                                        return newParams;
                                    });
                                }}
                            />
                        </Grid>
                        {store?.events?.length > 0 && (
                            <Grid item xs={12} md={4}>
                                <Paper variant="outlined" sx={{ p: 2, mt: { xs: 2, md: 0 } }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Comissões - {store.name}
                                    </Typography>
                                    <List dense disablePadding>
                                        {store.events.map((eventItem, index) => (
                                            <ListItem key={index} disableGutters divider={index < store.events.length - 1}>
                                                <ListItemText
                                                    primary={eventItem.event}
                                                    secondary={
                                                        <>
                                                            Tipo: {eventItem.eventType} <br />
                                                            Comissão:{' '}
                                                            {eventItem.fixedCommission
                                                                ? `R$ ${eventItem.commission.toFixed(2)}`
                                                                : `${(eventItem.commission * 100).toFixed(2)}%`}
                                                        </>
                                                    }
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Paper>
                            </Grid>
                        )}
                    </Grid>
                </CardContent>
                <Divider />

                <List size="md" sx={{ gap: 1 }}>
                    <>
                        {!Boolean(store) && (
                            <Paper sx={{ p: 4, border: 0 }}>
                                <Stack direction="row" justifyContent="center" gap={1}>
                                    <Typography>Selecione uma loja para ver os cupons.</Typography>
                                </Stack>
                            </Paper>
                        )}

                        {Boolean(store) && data?.pagination.totalSize === 0 && (
                            <Paper sx={{ p: 4, border: 0 }}>
                                <Stack direction="row" justifyContent="center" gap={1}>
                                    <Typography>Nenhum cupom encontrado.</Typography>
                                    <BlockOutlined />
                                </Stack>
                            </Paper>
                        )}

                        {Boolean(store) &&
                            data?.pagination.totalSize > 0 &&
                            data?.coupons
                                .filter(item => !data?.syncedOffers?.includes(item.id))
                                ?.map(item => (
                                    <React.Fragment key={`coupon_item_${item.id}`}>
                                        <ListItem
                                            secondaryAction={
                                                <IconButton onClick={() => openOfferSyncModal(item)}>
                                                    <ChevronRight />
                                                </IconButton>
                                            }
                                        >
                                            <ListItemAvatar>
                                                <Avatar
                                                    src={item.store?.image}
                                                    variant="rounded"
                                                    sx={{ border: '1px solid #eee', objectFit: 'cover', width: 50, height: 50 }}
                                                />
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={item.store?.name || 'Loja Desconhecida'}
                                                primaryTypographyProps={{ variant: 'title-md' }}
                                                secondary={
                                                    <Stack spacing={0.5} pt={0.5}>
                                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }} gutterBottom>
                                                            {item.description}
                                                        </Typography>
                                                        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ mb: 0.5 }}>
                                                            <Chip size="small" label={item.id} />
                                                            {item.category?.name && <Chip size="small" label={item.category.name} />}
                                                            {item.code && item.code !== 'URL CUPONADA' ? (
                                                                <Chip
                                                                    size="small"
                                                                    label={`Código: ${item.code}`}
                                                                    variant="outlined"
                                                                    color="primary"
                                                                />
                                                            ) : (
                                                                <Chip size="small" label="Oferta ativada no link" variant="outlined" color="info" />
                                                            )}
                                                            {/* Show discount percentage only if it's meaningful (e.g., not 100% if it means "free shipping" described elsewhere) */}
                                                            {typeof item.discount === 'number' && item.discount > 0 && item.discount < 100 && (
                                                                <Chip size="small" label={`${item.discount}% OFF`} color="secondary" />
                                                            )}
                                                        </Stack>
                                                        <Typography variant="caption" color="text.secondary">
                                                            Válido até: {formatVigency(item.vigency)}
                                                        </Typography>
                                                    </Stack>
                                                }
                                            />
                                        </ListItem>
                                        <Divider />
                                    </React.Fragment>
                                ))}
                    </>
                </List>

                <Stack direction="row" py={2} justifyContent="center">
                    <Pagination page={data?.page || 1} count={data?.pages || 1} onChange={handlePage} />
                </Stack>
            </Card>

            <DialogOffer mutate={mutate} coupon={coupon} />
            <DialogAdvertiser mutate={mutate} coupon={coupon} />
        </Container>
    );
}
